<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <!--<Avatar :src="userAvatar"/>-->
      </Badge>
      <div class="dis-flex align-center">
        <div class="text-center">
          <Icon class="line-h-1" size="24" type="md-contact" />
          <p class="username-p line-h-1">{{ username }}</p>
        </div>
        <Icon :size="18" type="md-arrow-dropdown"></Icon>
      </div>
      <DropdownMenu slot="list">
        <DropdownItem name="logout">{{ $t('components.user.signOut') }}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      username: '',
    };
  },
  created() {
    if (!window.localStorage.getItem) return;
    const getUserName = window.localStorage.getItem('username');
    this.username = getUserName || '';
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    logout () {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user_type');
        localStorage.removeItem('username');
        this.$router.push({
          name: 'login'
        });
        this.$store.commit('setNewMenuList', [])
        this.$store.commit('SETPUBLICSIDEMENU', []);
      } catch(e) {
        console.log(e);
      }
    },
    message () {
      this.$router.push({
        name: 'message_page'
      })
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'message': this.message()
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .user-avatar-dropdown {
    & >>> .ivu-dropdown-rel {
      line-height: 1;
    }
    .username-p {
      max-width: 50px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .line-h-1 {
      line-height: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue